module.exports = __webpack_public_path__ + "media/pricing/books-7098c9f3.png";